import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M13.5 8h-8c-.28 0-.5.22-.5.5 0 .27.22.5.5.5h8c.28 0 .5-.23.5-.5 0-.28-.22-.5-.5-.5zM13.5 10h-8c-.28 0-.5.22-.5.5 0 .27.22.5.5.5h8c.28 0 .5-.23.5-.5 0-.28-.22-.5-.5-.5zM13.5 12h-8c-.28 0-.5.22-.5.5 0 .27.22.5.5.5h8c.28 0 .5-.23.5-.5 0-.28-.22-.5-.5-.5zM9.5 14h-4c-.28 0-.5.22-.5.5 0 .27.22.5.5.5h4c.28 0 .5-.23.5-.5 0-.28-.22-.5-.5-.5z',
    'M15 2H4c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM4 3h11c.55 0 1 .45 1 1v1H3V4c0-.55.45-1 1-1zm11 15H4c-.55 0-1-.45-1-1V6h13v11c0 .55-.45 1-1 1z',
  ],
  height: 20,
  width: 20,
});
